<template>
    <div class="list">
        <div class="preview-goods" v-if="list.length > 0">
          <div class="prize">
            <div class="left-title">
              <img src="https://cdn-arch-common-prod.cotticoffee.com/cottih5/lottery-upcoming-icon.png">
              <div class="titsty">活动预告</div>
            </div>
          </div>
          <div class="upcomeing-more-list">
            <div v-for="(item, index) in list" :key="index" class="upcoming-item">
              <div class="upcoming-title" :class="comingShow ? 'title': 'title-no-btn'">{{ item.name }}</div>
              <div class="upcoming-body">
                <div class="upcoming-time">{{ item.activityStartTimeNow}}{{ ' ' }}</div>
                <div class="upcoming-btn" @click="addCalendar(index)" v-if="comingShow">
                  <img src="https://cdn-arch-common-prod.cotticoffee.com/cottih5/lottery-upcoming-toast.png" />
                  <div class="upcoming-text">提醒我</div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </template>
  
  <script>
  import { Base64 } from 'js-base64'
  import {transformTinyUrl} from '@/api/pointsActivity'
  import { isCottiApp } from '../../../utils'
  export default {
    name: "upComingList",
    props: {
      activityNo: {
        type: String,
        default: '',
      },
      list: {
        type: Array,
        default: [],
      },
    },
    data() {
      return {
        comingShow: false,
        upComingList: [],
      }
    },
    mounted() {
        if (isCottiApp) {
            const userAgent = navigator.userAgent.split('/')
            if (userAgent[0]=='cottiCoffee' && Number(userAgent[1]) >= 175) {
                this.comingShow = true
            } else if (userAgent[0]=='teacat' && Number(userAgent[1]) >= 112) {
                this.comingShow = true
            }
        } else {
          this.comingShow = false
        }
    },
    methods: {
        addCalendar(index) {
            var url = ''
            this.$emit('btnClick')
            transformTinyUrl({ url: this.$config.env.VUE_APP_DOWNLOAD + '#/transferPage?c=2&page=' + Base64.encode(window.location.href.split('?')[0] + '?auth=' + this.$route.query.auth + '&abiteol_tylq=' + this.$route.query.abiteol_tylq + '&activityNo='+ this.list[index].no) + '&type=3'}).then(res => {
                url = res.data
                console.log(url,'url')
                const params = JSON.stringify(
                    {
                        title: '库迪咖啡活动开始提醒',
                        startTime: this.list[index].activityStartTime,
                        description: this.list[index].name + '已经开始啦，快来参与吧！' + '\n' + url,
                        url: url
                    })
                try { 
                    createCalendarEvent.postMessage(params)
                } catch(e) {

                }
            }) 
        }
    },
  }
  </script>
  
  <style lang="scss" scoped>
  .list{
    width: 100%;
    .preview-goods {
    position: relative;
    padding: 24px;
    // bottom: 0;
    background: #FFFFFF;
    border-radius: 8px;
    margin-top: 120px;
    margin: 0 24px 24px 24px;
    .prize {
      display: flex;
      align-items: center;
      font-size: 24px;
      font-weight: 500;
      color: #3A3B3C;
      margin: 14px 0 22px 0;
      justify-content: space-between;
      img {
        width: 32px;
        height: 32px;
        margin-right: 4px;
        vertical-align: text-bottom;
      }
      .text {
        font-size: 22px;
        color: #5E5E5E;
        margin-left: 8px;
        ::v-deep span {
          color: #A52337;
          font-size: 28px;
        }
      }
      .left-title {
        display: flex;
        font-size: 28px;
        align-items: center;
        font-family: "D-DIN-PRO-500-Medium";

        span {
          margin: 0 4px;
        }

        .meexchange {
          margin: 5px 0 0 4px;
        }

        .exchange-icon {
          width: 26px;
          height: 26px;
        }

        .titsty {
          margin-top: 3px;
          margin-left: 8px;
        }

        .titsty-start{
          margin-top: 2px;
        }
      }

      .textFlex {
        align-items: flex-end;
      }

      .more {
        display: flex;
        align-items: center;
        color: #5E5E5E;
        font-size: 24px;

        img {
          width: 32px;
        }
      }
    }
    .upcomeing-more-list {
      display: flex;
      flex-direction: column;
      .upcoming-item {
        display: flex;
        flex-direction: row;
        margin: 8px 0px;
        background: #F5F5F5;
        border-radius: 8px;
        height: 80px;
        align-items: center;
        padding: 0 16px 0 16px;
        .upcoming-title {
          font-size: 24px;
          color: #3A3B3C;
          line-height: 32px;
          text-align: left;
          white-space: nowrap; /* 确保文本在一行内显示 */
          overflow: hidden; /* 隐藏超出容器的内容 */
          text-overflow: ellipsis; /* 使用省略号表示被截断的文本 */
        }
        .title {
          width: 368px; /* 定义容器宽度 */
        }
        .title-no-btn {
          width: 468px; /* 定义容器宽度 */
        }
        .upcoming-body {
          flex: 1;
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          height: 32px;
          .upcoming-time {
            font-weight: 400;
            font-size: 20px;
            color: #5E5E5E;
            line-height: 34px;
            text-align: right;
            font-style: normal;
          }

          .upcoming-btn {
            display: flex;
            flex-direction: row;
            background: #FFEEEC;
            border-radius: 18px;
            border: 1px solid #FFFFFF;
            padding: 6px 8px 6px 6px;
            margin-left: 6px;
            justify-content: center;
            align-items: center;
            img{
              width: 20px; 
              // height: 22px;
            }
            .upcoming-text {
              font-weight: 600;
              font-size: 18px;
              color: #A52337;
              text-align: center;
              margin-left: 2px;
            }

          }
        }
        
      }
    }
  }
  }
  </style>
  